<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents.html" xml:lang="en-US">
<div class="Basic-Text-Frame-21">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Chapter_One#Anchor-1">Chapter One</a></p>
<p class="TOCitem"><a href="#/Chapter_Two#Anchor-1">Chapter Two</a></p>
<p class="TOCitem"><a href="#/Chapter_Three#Anchor-1">Chapter Three</a></p>
<p class="TOCitem"><span href="#/Chapter_Four#Anchor-1" title="Link target outside of Sample">Chapter Four</span></p>
<p class="TOCitem"><span href="#/Chapter_Five#Anchor-1" title="Link target outside of Sample">Chapter Five</span></p>
<p class="TOCitem"><span href="#/Chapter_Six#Anchor-1" title="Link target outside of Sample">Chapter Six</span></p>
<p class="TOCitem"><span href="#/Chapter_Seven#Anchor-1" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="TOCitem"><span href="#/Chapter_Eight#Anchor-1" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="TOCitem"><span href="#/Chapter_Nine#Anchor-1" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="TOCitem"><span href="#/Chapter_Ten#Anchor-1" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="TOCitem"><span href="#/Chapter_Eleven#Anchor-1" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="TOCitem"><span href="#/Chapter_Twelve#Anchor-1" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="TOCitem"><span href="#/Chapter_Thirteen#Anchor-1" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Fourteen#Anchor-1" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Fifteen#Anchor-1" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Sixteen#Anchor-1" title="Link target outside of Sample">Chapter Sixteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Seventeen#Anchor-1" title="Link target outside of Sample">Chapter Seventeen</span></p>
<p class="TOCitem"><span href="#/Chapter_Eighteen#Anchor-1" title="Link target outside of Sample">Chapter Eighteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Nineteen#Anchor-1" title="Link target outside of Sample">Chapter Nineteen</span></p>
<p class="TOCitem"><span href="#/Chapter_Twenty#Anchor-1" title="Link target outside of Sample">Chapter Twenty</span></p>
<p class="TOCitem"><span href="#/Dear_Reader#Anchor-1" title="Link target outside of Sample">Dear Reader</span></p>
<p class="TOCitem"><span href="#/Excerpt#Anchor-1" title="Link target outside of Sample">Excerpt from <em>Stand-In Rancher Daddy</em> by Renee Ryan</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0d880846